var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about fill-height transparent flex-fill px-3"},[_c('HeaderPanel',{attrs:{"data":_vm.store.homeHeader}}),(_vm.$vuetify.breakpoint.smAndDown)?_c('BackButton',{attrs:{"label":"Home","to":"/"}}):_vm._e(),_c('AboutPanel',{attrs:{"data":_vm.store.descriptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }